import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  partner: {
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.PartnerSelect.partner`,
    defaultMessage: 'Partner',
  },
});
